import router from './../../router';

const state = {
  details: null,
  gdAccess: false,
  needNewPassword: false,
  role: 'unknow',
};

const getters = {
  details: store => store.details,
  gdAccess: store => store.gdAccess,
  needNewPassword: store => store.needNewPassword,
  role: store => store.role,
};

const mutations = {
  SET_USER(state, user) {
    if (user && user.role) {
      if (typeof user.role === 'string') {
        state.role = user.role;
      }
      delete user.role;
    }
    state.details = user;
  },
  SET_GD_ACCESS(state, access) {
    state.gdAccess = access;
  },
  SET_NEED_NEW_PASSWORD(state, access) {
    state.needNewPassword = access;
  },
};

const actions = {
  setUser({ commit, dispatch }, user) {
    if (user) {
      dispatch('setGdAccess', user.gd_access);
      delete user.gd_access;
    }
    commit('SET_USER', user);
  },
  setGdAccess({ commit }, access) {
    commit('SET_GD_ACCESS', access);
  },
  setNeedPassword({ commit }, status) {
    commit('SET_NEED_NEW_PASSWORD', status);
  },
  setPasswordRedirect({ commit }) {
    commit('SET_NEED_NEW_PASSWORD', true);
    router.push('/ustaw-haslo');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
